import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../../assets/images/attachment.png'


const _withScopeId = n => (_pushScopeId("data-v-7c99840c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gd-attachment mb-gutter" }
const _hoisted_2 = { class: "mb-gutter" }
const _hoisted_3 = { class: "gd-file-list font-small" }
const _hoisted_4 = { class: "list-styled" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "legal__attachment"
}, null, -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "legal__attachmentlist" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-field form-field--gd" }, null, -1))
const _hoisted_9 = { class: "form-field form-field--gd" }
const _hoisted_10 = { class: "field-row gd-form-declaration" }
const _hoisted_11 = { class: "form-field form-field--gd" }
const _hoisted_12 = { class: "field-row gd-form-declaration" }
const _hoisted_13 = { class: "gd-field__option" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-checkbox" }, null, -1))
const _hoisted_16 = {
  class: "label label--text label--inline label--multi-line no-padding",
  "data-auto": "Declaration-lbl"
}
const _hoisted_17 = { class: "form-field form-field--gd" }
const _hoisted_18 = { class: "field-row gd-form-declaration" }
const _hoisted_19 = { class: "form-field form-field--gd" }
const _hoisted_20 = { class: "field-row gd-form-declaration" }
const _hoisted_21 = { class: "form-field form-field--gd" }
const _hoisted_22 = { class: "field-row gd-form-declaration" }
const _hoisted_23 = { class: "gd-field__option" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-checkbox" }, null, -1))
const _hoisted_26 = {
  class: "label label--text label--inline label--multi-line no-padding",
  "data-auto": "ColleagueDeclaration-lbl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(`${_ctx.getTranslatedValueEx("labeltext.partB")} ${_ctx.getTranslatedValueEx(
            "labeltext.formCompletionHeader"
          )}`), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newUser.DocumentList, (doc, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _hoisted_5,
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.downloadAttachments(doc.Guid, doc.FileLocation)),
              class: "legal__attachmentlist"
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getTranslatedValueEx(
                  `labeltext.${_ctx.getSelectedDocName(doc.DocumentTypeId)}`
                )) + " - ", 1),
              _createTextVNode(" " + _toDisplayString(doc.FileLocation), 1)
            ], 8, _hoisted_6)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("h3", null, _toDisplayString(`${_ctx.getTranslatedValueEx(
            "labeltext.declarationHeader1"
          )} ${_ctx.getTranslatedValueEx("labeltext.declarationHeader2")}`), 1)
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.declarationType1")), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "Declaration",
            value: "Declaration",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.initModel.Declaration) = $event)),
            name: "tncdeclaration",
            disabled: _ctx.initModel.isDisabled
          }, null, 8, _hoisted_14), [
            [_vModelCheckbox, _ctx.initModel.Declaration]
          ]),
          _hoisted_15
        ]),
        _createTextVNode("   "),
        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.declarationText")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('labeltext.declarationSubHeader1')), 1)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.getTranslatedValueWithParams("labeltext.declarationType2", {
            brandPlcName1: _ctx.initModel.brandPlcName,
          })), 1)
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("label", _hoisted_22, [
        _createElementVNode("span", _hoisted_23, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "ColleagueDeclaration",
            value: "ColleagueDeclaration",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.initModel.ColleagueDeclaration) = $event)),
            name: "tnccolleaguedeclaration",
            disabled: _ctx.initModel.isDisabled
          }, null, 8, _hoisted_24), [
            [_vModelCheckbox, _ctx.initModel.ColleagueDeclaration]
          ]),
          _hoisted_25
        ]),
        _createTextVNode("   "),
        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.declarationtext2")), 1)
      ])
    ])
  ]))
}